import React from 'react';

import {
  FullWidthCardContainer,
  FullWidthCardContentWrapper,
  FullWidthCardDescription,
  FullWidthCardInfo,
  FullWidthCardTitle,
} from './styled';

export * from './styled';

type FullWidthWizardCardBaseProps = {
  children: React.ReactNode;
  compact?: boolean;
};

type FullWidthWizardCardProps = FullWidthWizardCardBaseProps &
  (
    | {
        description: React.ReactNode;
        noInfo?: never;
        title: string;
      }
    | {
        description?: never;
        noInfo: true;
        title?: never;
      }
  );

export function FullWidthWizardCard({ children, compact, title, description, noInfo }: FullWidthWizardCardProps) {
  return (
    <FullWidthCardContainer $compact={compact}>
      {!noInfo && (
        <FullWidthCardInfo $alignLeft={compact}>
          <FullWidthCardTitle $compact={compact}>{title}</FullWidthCardTitle>
          <FullWidthCardDescription $compact={compact}>{description}</FullWidthCardDescription>
        </FullWidthCardInfo>
      )}
      <FullWidthCardContentWrapper>{children}</FullWidthCardContentWrapper>
    </FullWidthCardContainer>
  );
}
